"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BtnSyncInvoice = class BtnSyncInvoice extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    beforeDestroy(...args) {
        {
            {
                this.invoiceSyncPoller && this.invoiceSyncPoller.stop();
            }
        }
    }
    checkStatus(...args) {
        if (!this.jobData) {
            console.log('JobData is null, stop polling.');
            this.invoiceSyncPoller.stop();
            return;
        }
        const status = this.jobData.status;
        if (status !== 'pending' && status !== 'running') {
            console.log(`JobStatus is ${status}, stop polling.`, this.invoiceSyncPoller);
            this.invoiceSyncPoller.stop();
            this.$emit('success');
            return;
        }
        this.$fn
            .fetch('read_a_job', { parameters: { id: this.jobData.id } })
            .then(data => this.jobData = data)
            .catch(err => {
            console.error(err);
            this.invoiceSyncPoller.stop();
        });
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    jobData;
    invoiceSyncPoller;
    async $$load_invoiceSyncPoller() {
        return this.$fn.poller({ id: 'InvoiceSync', callback: this.checkStatus });
    }
    messages;
    statuses;
    ux;
    dataMembers = ['jobData', 'invoiceSyncPoller', 'messages', 'statuses', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                jobData: null,
                invoiceSyncPoller: null,
                messages: {
                    createButtonText: "Számla kiállítása",
                    createButtonTitle: "A számla kiállítása a számlázó szolgáltatónál",
                    syncButtonTooltip: "Szinkronizálás",
                    confirmSyncDialog: {
                        header: "Számla szinkronizálása",
                        message: "A számlát csak egyszer lehet feltölteni a szamlazz.hu rendszerébe, feltöltés után a számlát már nem lehet módosítani.",
                        btnOk: "Szinkronizálás",
                        btnCancel: "Mégsem",
                    },
                    cancelSyncDialog: {
                        header: "Szinkronizálás megszakítása",
                        message: "Megszakítás esetén a számla nem lesz szinkronizálva.\n\
Tartalma módosítható, szerkesztés után az új adattartalommal újra szinkronizálható.\n\
A sor feldolgozása a megaszakított elemnél szünetel.\n\
",
                        btnOk: "Megszakítás",
                        btnCancel: "Mégsem",
                    },
                    showLogMessagesTooltip: "Naplófile megtekintése.",
                },
                statuses: {
                    default: {
                        variant: "primary",
                        text: "Számla kiállítása",
                        tooltip: "A számla kiállítása a számlázó szolgáltatónál",
                    },
                    pending: {
                        icon: "material-symbols:lock-clock-outline-sharp",
                        color: "bg-yellow-200",
                        variant: "warning",
                        text: "Számla kiállítása folyamatban",
                        tooltip: "A számla szinkronizálásra vár, ebben az állapotában nem módosítható.",
                    },
                    retry: {
                        icon: "material-symbols:lock-clock-outline-sharp",
                        color: "bg-yellow-200",
                        variant: "warning",
                        text: "Számla kiállítása folyamatban",
                        tooltip: "A számla szinkronizálás alatt.",
                    },
                    processing: {
                        icon: "material-symbols:cloud-sync-rounded",
                        color: "bg-blue-200",
                        variant: "warning",
                        text: "Számla kiállítása folyamatban",
                        tooltip: "A számla szinkronizálás alatt.",
                    },
                    failed: {
                        icon: "material-symbols:sync-problem-outline-rounded",
                        color: "bg-red-200",
                        variant: "danger",
                        text: "Számla kiállítás hiba",
                        tooltip: "Hiba történt a szinkronizálás során.",
                    },
                    cancelled: {
                        icon: "material-symbols:sync-disabled",
                        color: "bg-gray-200",
                        variant: "secondary",
                        text: "Számla kiállítás megszakítva",
                        tooltip: "A számla törölve lett a szinkronizálási sorból.",
                    },
                },
                ux: null,
            },
        };
    }
    get status() {
        if (this.loaded) {
            return this.jobData ? this.jobData.status : (this.invoice.sync_job ? this.invoice.sync_job.status : null);
        }
        return null;
    }
    get context() {
        if (this.loaded) {
            return this.statuses[this.status || 'default'];
        }
        return null;
    }
    get isJobRunning() {
        if (this.loaded) {
            return this.status === 'running' || this.status === 'pending';
        }
        return null;
    }
    async act_2248226175642056_setData_7150_getActionArgs($event) {
        return {
            path: "jobData",
            value: $event.data.modalResult && $event.data.modalResult.value,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_close_7149_getWhen($event) {
        return $event.data.modalResult && $event.data.modalResult.ok;
    }
    async act_2248226175642056_script_7152_getActionArgs_value($event) {
        this.invoiceSyncPoller.start();
    }
    async act_2248226175642056_script_7152_getActionArgs($event) {
        return {
            value: () => this.act_2248226175642056_script_7152_getActionArgs_value($event),
        };
    }
    async evh_2248226175642056_close_7151_getWhen($event) {
        return $event.data.modalResult && $event.data.modalResult.ok;
    }
    async act_2248226175642056_showModal_7148_getActionArgs($event) {
        return {
            name: "ConfirmSyncInvoice",
            props: {
                invoice: this.invoice,
            },
        };
    }
    async evh_2248226175642056_clickPreventStop(event, scope) {
        return await this.actions.evh_2248226175642056_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_showModal_7154_getActionArgs($event) {
        return {
            name: "Job",
            props: {
                oid: this.invoice.sync_job.id,
            },
        };
    }
    async evh_5962862420439144_clickPreventStop(event, scope) {
        return await this.actions.evh_5962862420439144_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_2248226175642056_setData_7150 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_7150_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_close_7149 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_7150,
            event: "close",
            when: this.evh_2248226175642056_close_7149_getWhen,
            displayName: "setData",
        });
        const act_2248226175642056_script_7152 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2248226175642056_script_7152_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_close_7151 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_script_7152,
            event: "close",
            when: this.evh_2248226175642056_close_7151_getWhen,
            displayName: "script",
        });
        const act_2248226175642056_showModal_7148 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_7148_getActionArgs,
            displayName: "sync",
            events: [evh_2248226175642056_close_7149, evh_2248226175642056_close_7151],
        });
        const evh_2248226175642056_clickPreventStop_7147 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_7148,
            event: "click.prevent.stop",
            displayName: "sync",
        });
        const evh_2248226175642056_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_clickPreventStop_7147],
        });
        const act_5962862420439144_showModal_7154 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5962862420439144_showModal_7154_getActionArgs,
            displayName: "showJob",
            events: [],
        });
        const evh_5962862420439144_clickPreventStop_7153 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_showModal_7154,
            event: "click.prevent.stop",
            displayName: "showJob",
        });
        const evh_5962862420439144_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_clickPreventStop_7153],
        });
        return {
            act_2248226175642056_setData_7150,
            evh_2248226175642056_close_7149,
            act_2248226175642056_script_7152,
            evh_2248226175642056_close_7151,
            act_2248226175642056_showModal_7148,
            evh_2248226175642056_clickPreventStop_7147,
            evh_2248226175642056_clickPreventStop,
            act_5962862420439144_showModal_7154,
            evh_5962862420439144_clickPreventStop_7153,
            evh_5962862420439144_clickPreventStop,
            sync: act_2248226175642056_showModal_7148,
            showJob: act_5962862420439144_showModal_7154,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], BtnSyncInvoice.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnSyncInvoice.prototype, "onInvoice", null);
BtnSyncInvoice = __decorate([
    (0, vue_property_decorator_1.Component)()
], BtnSyncInvoice);
exports.default = BtnSyncInvoice;
vue_property_decorator_1.Vue.component("BtnSyncInvoice", BtnSyncInvoice);
